module.exports = __webpack_public_path__ + "images/thumb-2584e2bb944613bbd0bd40e89f2d5baf.jpg";